import {
    chakra, Flex, Text
} from '@chakra-ui/react';

export const LeftNavButtonText = chakra(Text, {
    label: 'LeftNavButtonText',
    baseStyle: {
        fontFamily: 'Poppins, sans-serif',
        fontStyle: 'normal',
        letterSpacing: '-0.2px',
        lineHeight: '13px',
        textAlign: 'center',
        marginTop: '5px'
    }
});

export const LeftNavButtonUI = chakra(Flex, {
    label: 'LeftNavButtonUI',
    baseStyle: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        w: '100%',
        minW: '70px',
        minH: '75px',
        backgroundColor: 'transparent',
        cursor: 'pointer',
        boxSizing: 'border-box',
        color: 'neutral.700',
        _first: { ['&.active']: { borderTopRightRadius: '0' } },
        ['svg, svg path']: { opacity: 0.8 },
        _hover: {
            ['svg, svg path']: {
                fill: 'var(--3p-colors-primary-600) !important',
                stroke: 'var(--3p-colors-primary-600) !important',
                opacity: 1
            }
        },
        ['&.active']: {
            backgroundColor: 'primary.700',
            color: 'neutral.50',
            fontWeight: '500',
            borderTopRightRadius: '20px',
            borderBottomRightRadius: '20px',
            transition: ' background-color 0.2s ease, color 0.2s ease, font-weight 0.2s ease',
            ['svg, svg path']: {
                fill: 'var(--3p-colors-neutral-50) !important',
                stroke: 'var(--3p-colors-neutral-50) !important',
                opacity: 1
            }
        },
        ['&:hover:not(.active), &.__hover:not(.active)']: {
            backgroundColor: 'neutral.100',
            ['> div']: { color: 'primary.800' }
        }
    }
});
